<template>
    <div>
        <canvas id="workcenter-chart"></canvas>
    </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'Workcenter-Chart',

  props: {
    colors: {
      type: Array,
      default: () => [
        '#4caf50', '#2196f3', '#ff9800', '#f44336', '#9c27b0', '#00bcd4',
        '#8bc34a', '#795548', '#607d8b', '#e91e63', '#3f51b5', '#009688',
        '#cddc39', '#ffc107', '#ff5722', '#673ab7',
      ],
    },
  },

  data() {
    return {
      chartObj: null,
      wcChartData: {
        type: 'doughnut',
        data: {
          labels: [],
          datasets: [
            {
              label: 'Total Trabajadores',
              data: [],
              backgroundColor: this.colors,
              borderColor: '#fff',
              borderWidth: 1,
            },
          ],
        },
        options: {
          layout: {
            padding: {
              left: 10,
              right: 10,
              top: 10,
              bottom: 10,
            },
          },
          plugins: {
            legend: {
              position: 'right',
              labels: {
                boxWidth: 12,
                font: {
                  size: 11,
                },
              },
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      },
    };
  },

  mounted() {
    const ctx = document.getElementById('workcenter-chart');
    // eslint-disable-next-line no-new
    this.chartObj = new Chart(ctx, this.wcChartData);
  },

  methods: {
    updateChartData(workcenters) {
      if (!this.chartObj || !workcenters) return;

      const labels = workcenters.map((w) => w.text || w.name);
      const data = workcenters.map((w) => w.totalWorkers || 0);
      const bgColors = labels.map((_, i) => this.colors[i % this.colors.length]);

      this.wcChartData.data.labels = labels;
      this.wcChartData.data.datasets[0].data = data;
      this.wcChartData.data.datasets[0].backgroundColor = bgColors;

      this.chartObj.update();
    },
  },
};
</script>
